import React, { Component } from 'react';
import NavMenu from '../../components/navMenu/navMenu';
import HeaderMenu from '../../components/headerMenu/headerMenu';
import '../../assets/css/common.less';
import { requests, getToken, loadZhuKeToken,getLoginShopInfo,systemConfig,getZkShopName,getTaoteShopName  } from '../../utils/http';
import { Input, Select, Tabs, Button, Pagination, Checkbox, Radio, Message, Loading, Tooltip, Tag, Dialog } from 'element-react';
import MyLoading from '../../components/showLoading/showLoading';
import ShowWarn from '../../components/showWarn/showWarn';
import NewUserGuide from '../../components/newUserGuide/index.jsx';
import { otherExposureReport } from '../../utils/alibabareport.js';

class autoAfterSaleLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alibabaPageKey:'after-sales_log',
      daySelect: [{ value: "1", label: "24小时",isSelect:true},{ value: "7", label: "7天",isSelect:false}, { value: "15", label: "15天",isSelect:false }, { value: "30", label: "30天",isSelect:false }],
      selectDay:"1",
      selectShopId: "",//当前登录的店铺id，非阿里的
      selectShopName:'',//列表显示的店铺名称
      selectplatformType: "WxVideo",//当前登录的店铺类型

      selectOperateType:"-1",//选择的操作类型
      selectOperateStatus:"",//选择的操作状态
      selectByOrderType:"PlatformOrderId",//选择的订单类型
      inputOrderValue:"",//输入的值

      isNotList:false,//是否未空列表
      logList:[],//日志列表
      pageSize: 10,
      current: 1,
      total: 0,
    };
  }
  componentDidMount() {
    var zhukeToken=getToken();
    var that=this;
    if(zhukeToken !="")
    {
       that.loadData();
       otherExposureReport(this.state.alibabaPageKey);
    }
    else{

      setTimeout(() => {
        var zhukeTokenTwo=getToken();
        if(zhukeTokenTwo ==""){
          var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
          //var hasZhukeLoginShopTokens = "";//测试。
          if(hasZhukeLoginShopTokens !=null && hasZhukeLoginShopTokens !="" && hasZhukeLoginShopTokens !=undefined)
          {
            loadZhuKeToken(hasZhukeLoginShopTokens);

            setTimeout(() => {
              var zhukeTokenThree=getToken();
              if(zhukeTokenThree !="")
                 that.loadData();
              else
                that.setState({isShowWarn: true});
              
            }, 500);
          }else
             that.setState({ isShowWarn: true}); 
        }else
          that.loadData();
      }, 500);
      
    }
  }


  loadData=()=>{
    var shopInfo=getLoginShopInfo();
    var that=this;
    this.setState({
      selectShopId:shopInfo.loginShopId,
      selectShopName:shopInfo.loginShopName,
      selectplatformType:shopInfo.loginShopPlatformType,
    },()=>{
      that.queryButton();
    })
   
  }

  


  loadLogList=()=>{
    if(this.state.isShowWarn){
      Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
      return;
    }

    
    var data = {
      ShopId: [this.state.selectShopId],
      PageName: 'autoAfterSaleLog',
      Days: this.state.selectDay,
      OperateType: this.state.selectOperateType,
      OperateStatus: this.state.selectOperateStatus,
      PlatformOrderId: '',
      PurchaseOrderId: '',
      PageIndex: this.state.current,
      PageSize: this.state.pageSize
  };

  var orderByType = this.state.selectByOrderType;
  if (orderByType == "PlatformOrderId")
      data.PlatformOrderId = this.state.inputOrderValue;//商品id
  else
      data.PurchaseOrderId = this.state.inputOrderValue;//商品标题
    
    var that=this;
    that.setState({ isLoading: true });
    requests({
      url: "/Auto/GetRecordList",
      data: data,
      success: (res) => {
        that.setState({ isLoading: false });
        if (res.Success) {
          var listData = res.Data.ResultList;
          var totals = res.Data.TotalCount;
          if (listData == null || listData == undefined)
              listData = [];


          for (let i = 0; i < listData.length; i++) {
              listData[i].ShopName = this.state.selectShopName;
          }

          var isNotList=false;
          if(listData.length==0)
              isNotList=true;

          that.setState({ logList: listData, total: totals,isNotList:isNotList });
        } else {
          Message({
            showClose: true,
            message: res.Message,
            type: 'error'
          });
        }
      },
      fail: (err) => { }
    })
    

  }


  queryButton = (isQuery) => {
    if (isQuery) {  //为true 时为搜索调用  current恢复第1页
      this.setState({ current: 1 }, () => {
          this.loadLogList();
      })
    } else {     //为切换页码时调用
        this.loadLogList();
    }
  }

  changeNav = (name) => {
    this.props.history.replace(name)
  }

  changeSelect = (name, value) => {
    this.setState({
      [name]: value
    })
  }

  onChangeInput = (name, value) => {
    let obj = {};
    obj[name] = value.trim();
    this.setState(obj);
  }

  
   //分页
  changeCurrent = (current) => {
    this.setState({
      current,
      checkAll: false
    }, () => {
      this.queryButton();
    })
  }
   //分页
  changePageSize = (size) => {
    this.setState({
      pageSize: size,
      current: 1,
    }, () => {
      this.queryButton();
    })
  }

  

  render() {

    return (
      <div className='wrap'>
        <HeaderMenu />
        <main>
          <div className='wrap-left scroll-x' >
            <NavMenu changeNav={this.changeNav} defaultActive={"/autoAfterSaleLog"} />
          </div>
          <div className="wrap-right">
            <ShowWarn isShow={this.state.isShowWarn} targetUrl={this.changeNav} 
                                    from_action={systemConfig.zhukeAlibabaAuth === false ? 'alibaba_auth_expire' : systemConfig.zhukeTaoteAuth === false ? 'taote_auth_expire' :null} 
                                    alibabaNickName={getZkShopName()} taoteNickName={getTaoteShopName()}/>

            <div className='searchWrap mywrap'>
              <Select onChange={this.changeSelect.bind(this, "selectDay")} value={this.state.selectDay} clearable={true} style={{ width: "200px", marginRight: "10px" }}	>
                {
                  this.state.daySelect.map((el) => {
                    return <Select.Option key={el.value} label={el.label} value={el.value} />
                  })
                }
              </Select>
              <Select onChange={this.changeSelect.bind(this, "selectOperateType")} value={this.state.selectOperateType} clearable={true} style={{ width: "200px", marginRight: "10px" }}	>
                  <Select.Option key="-1" label="全部操作类型" value="-1" />
                  <Select.Option key="2" label="采购单未支付-关闭" value="2" />
                  <Select.Option key="3" label="采购单已支付-退款" value="3" />
              </Select>
              <Select onChange={this.changeSelect.bind(this, "selectOperateStatus")} value={this.state.selectOperateStatus} clearable={true} style={{ width: "200px", marginRight: "10px" }}	>
                  <Select.Option key="" label="全部操作状态" value="" />
                  <Select.Option key="Success" label="成功" value="Success" />
                  <Select.Option key="Error" label="失败" value="Error" />
                  <Select.Option key="Deleted" label="已删除不处理" value="Deleted" />
              </Select>
              <Select onChange={this.changeSelect.bind(this, "selectByOrderType")} value={this.state.selectByOrderType} clearable={true} style={{ width: "200px", marginRight: "10px" }}	>
                  <Select.Option key="PlatformOrderId" label="店铺订单编码" value="PlatformOrderId" />
                  <Select.Option key="PurchaseOrderId" label="采购单编码" value="PurchaseOrderId" />
              </Select>
              <Input value={this.state.inputOrderValue} onChange={this.onChangeInput.bind(this, "inputOrderValue")} style={{ width: "200px", marginRight: "15px" }} placeholder='请输入' />
              <Button type="primary" onClick={() => this.queryButton(true)}>查询</Button>
            </div>

            <div className='mywrap'>
                    <table className="table-style01" id="orderList_table">
                        <thead>
                            <tr>
                                <th style={{ width: "130px" }}>操作时间</th>
                                <th style={{ width: "150px" }}>店铺名称</th>
                                <th style={{ width: "150px" }}>店铺订单编号</th>
                                <th style={{ width: "150px" }}>采购订单编号</th>
                                <th style={{ width: "150px" }}>操作类型</th>
                                <th style={{ width: "150px" }}>操作状态</th>
                                <th style={{ width: "150px" }}>说明</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* 订单无数据*/}
                            {
                                this.state.isNotList == true ?
                                    <tr>
                                        <td className="noneData" colSpan="20">
                                            <div className="noneData-wrap">
                                                <i className="iconfont icon-wushuju"></i>
                                                <span className="noneData-title">暂无数据！</span>
                                            </div>
                                        </td>
                                    </tr> : null
                            }

                            {/* 订单列表*/}
                            {
                               this.state.logList.map((item) =>
                                    <tr>
                                        <td className="">{item.UpdateTime}</td>
                                        <td className="">
                                            <div className='newPlatformIconWrap'>
                                                {/* <PlatformName platformType={item.PlatformType} isHidePatformName={true} /> */}
                                                <span style={{ marginLeft: "5px" }}>{item.ShopName}</span>
                                            </div>
                                        </td>
                                        <td className="">{item.PlatformOrderId}</td>
                                        <td className="">{item.PurchaseOrderId}</td>
                                        <td className="">{item.OperateTypeName}</td>
                                        <td className="">
                                            <div>
                                                <i class="dot-ZT"
                                                    style={{
                                                        backgroundColor:
                                                            item.OperateStatus == "Error" ? "#ff511c" :
                                                                item.OperateStatus == "Success" ? "#77bf04" :
                                                                    item.OperateStatus == "Deleted" ? "#f7941f" : "#3aadff"
                                                    }}></i>
                                                <span>{item.OperateStatusName}</span>
                                            </div>
                                        </td>
                                        <td style={{ color: "#ff511c" }}>{item.Remark}</td>
                                    </tr>
                                )
                            }

                        </tbody>
                    </table>
                    <div className='paginationwrap'>
                       <Pagination onCurrentChange={this.changeCurrent.bind(this)} onSizeChange={this.changePageSize.bind(this)} layout="total,sizes,prev, pager, next" total={this.state.total} pageSize={this.state.pageSize} currentPage={this.state.current} pageSizes={[10,30,50]} />
                    </div>
            </div>
          </div>
        </main>


        <MyLoading isLoading={this.state.isLoading} isStopOperate={true} fullCenter={true} />
        <NewUserGuide></NewUserGuide>
      </div>

    )
  }
}

export default autoAfterSaleLog;


// WEBPACK FOOTER //
// ./src/pages/autoAfterSaleLog/autoAfterSaleLog.jsx